import { InputGroup, Intent } from '@blueprintjs/core';
import * as React from 'react';
import { Field } from 'react-final-form';

import useClientTranslations from '../../../../hooks/useClientTranslations';
import { TractableFormGroup } from './Shared';

export const required = (field: string, t: any) => (value: any) =>
	value ? undefined : t(`{{field}} is required`, { field });

const PolicyholderName: React.FC = () => {
	const { t } = useClientTranslations();

	return (
		<Field name="policyholderName" validate={required(t('Policyholder name'), t)}>
			{({ input, meta }) => (
				<TractableFormGroup
					label={t('Policyholder name')}
					inline
					intent={Intent.DANGER}
					helperText={
						meta.invalid && meta.touched && (t(meta.error) || (!meta.dirtySinceLastSubmit && t(meta.submitError)))
					}
				>
					<InputGroup {...input} placeholder="" />
				</TractableFormGroup>
			)}
		</Field>
	);
};

export { PolicyholderName };
